import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { FAQCategories, FAQQuestions } from 'src/utils/dummy/faq/content';

const HeadC = dynamic(() => import('src/components/Head'));
const FAQPageJsonLdC = dynamic(() => import('src/components/Layout/JsonLd/FAQ'));
const FaqTopicsContainer = dynamic(() => import('src/containers/Faq/Topics'));

const FaqTopicListPage = (props: any) => {
	const { topic } = props;

	return (
		<>
			<HeadC
				title={`FAQ Terkait ${topic?.title}`}
				description={`Pusat bantuan dan FAQ terkait ${topic?.title} di KlikDokter.
				Simak pertanyaan yang banyak ditanyakan seputar layanan di sini.`}
			/>
			<FaqTopicsContainer {...props} />

			<FAQPageJsonLdC items={props.topicQuestions.slice(0, 10)} />
		</>
	);
};

export async function getStaticPaths() {
	return {
		paths: [],
		fallback: 'blocking',
	};
}

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
	(store) => async (context: any) => {
		const { slug } = context.params;

		await store.dispatch(actionGetMenu());
		await store.dispatch(actionGetFooterMenu());

		let topicSet = {
			title: 'Pertanyaan Umum',
			slug: 'umum',
		};

		const topic: any = FAQCategories.find((cat) => cat.slug === slug);

		if (!topic) {
			return {
				notFound: true,
			};
		}

		topicSet = {
			title: topic.title,
			slug: topic.slug,
		};

		const topicQuestions: any = FAQQuestions.filter((fq) => {
			let catSlug = null;
			if (topicSet.slug) {
				catSlug = topicSet.slug;
			}
			return fq.slug_category === catSlug;
		});

		return {
			props: {
				jsonLd: {
					organization: true,
					breadcrumbs: true,
				},
				pageHeaderContent: {
					title: 'FAQ',
					hideHeadingTitle: true,
					breadcrumbs: [
						{
							label: 'FAQ',
							navigatePath: '/faq',
						},
						{
							label: `List Pertanyaan untuk ${topicSet.title}`,
							navigatePath: null,
						},
					],
				},
				topic: topic,
				topicQuestions: topicQuestions,
			},
		};
	},
);

export default FaqTopicListPage;
